import { render } from "./AccZ.vue?vue&type=template&id=6b6bc74a"
import script from "./AccZ.vue?vue&type=script&lang=js"
export * from "./AccZ.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__